import { useState } from 'react'

import { WorkspaceProductDTO } from 'features/product/api/types/workspaceProductDTO'
import { WorkspaceProduct } from 'features/product/types/workspaceProduct'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { workspaceProductFromDTO } from './api/mapper'
import { GET_WORKSPACE_PRODUCTS } from './api/query'
import { Data } from './api/types'
import { UseGetWorkspaceProducts } from './types'

export const useGetWorkspaceProducts = (): UseGetWorkspaceProducts => {
  const [products, setProducts] = useState<WorkspaceProduct[]>([])

  const { isLoading } = useQuery<never, Data>({
    onCompleted: async data => {
      const { workspaceProducts } = data

      setProducts(
        workspaceProducts.map(
          (product: WorkspaceProductDTO): WorkspaceProduct => workspaceProductFromDTO(product),
        ),
      )
    },
    query: GET_WORKSPACE_PRODUCTS,
  })

  return {
    loading: isLoading,
    products,
  }
}
